<template>
  <div class="table-container">
  <table>
  <tbody>
    <tr v-for="client in results" :key="client.id" class="t-row">
      <td>{{ client.id }}</td>
      <td>
        {{ client.userName }}
      </td>
      <td>{{ client.code }}</td>
      <td>{{ client.points }}</td>
      <td>{{ client.firstName }}, {{ client.lastName }}</td>
      <td>{{ client.ssn }}</td>

      <td>
        {{ adminType(client.admin) ? adminType(client.admin) : "No" }}
      </td>
      <td class="text-center">
        <router-link
          :to="{ name: 'DivvyAdminUsersLockScreen', params: { id: client.id } }"
          @click.native="scrollToTop"
        >
          <img
            :src="'https://qa.incentiveweb.com/images/lock.gif'"
            alt="This user cannt login. Click to unlock this user."
            v-if="client.locked"
          />
          <img
            :src="'https://qa.incentiveweb.com/images/lockno.gif'"
            alt="This user can login. Click to unlock this user."
            v-if="!client.locked"
          />
        </router-link>
      </td>
      <td>
        <router-link
          class="btn btn-primary text-sm"
          :to="{ name: 'DivvyAdminUsersEditUser', params: { id: client.id } }"
          @click.native="scrollToTop"
        >
          Edit
        </router-link>
      </td>
      <td>
        <router-link
          class="btn btn-primary text-sm"
          :to="{
            name: 'DivvyAdminUsersPointsUpdate',
            params: { id: client.id },
          }"
          @click.native="scrollToTop"
        >
          Points
        </router-link>
      </td>
      <td>
        <button
          class="btn btn-success text-sm"
          @click="showOtpModal(client.id)"
        >
          Login
        </button>
      </td>
      <td>
        <router-link
          class="btn btn-primary text-sm"
          :to="{ name: 'DivvyAdminUsersReportUser', params: { id: client.id } }"
          @click.native="scrollToTop"
        >
          Report
        </router-link>
      </td>
    </tr>
  </tbody>
  </table>

  <div v-if="showModal" class="modal-backdrop">
      <div class="modal-content">
        <div class="modal-header">
          <h3>OTP Verification</h3>
          <button @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">
          <p>An OTP has been sent to the admin's registered email/phone</p>
          <input
            v-model="otpCode"
            type="text"
            placeholder="Enter OTP"
            class="otp-input"
            @keyup.enter="submitOtp"
          />

          <div class="modal-footer">
            <button @click="submitOtp" class="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import FrontendService from "../../../../services/FrontendService"
export default {
  name: "UsersTableData",
  data() {
    return {
      showModal: false,
      otpCode: "",
      currentUserId: null,
      divvy_admin_username: "",
      userID: "",
    };
  },
  computed: {
    results() {
      return this.$store.getters["manageUsers/getResult"];
    },
  },
  methods: {
    showOtpModal(userId) {
      this.currentUserId = userId;
      this.generateOTP(userId);
    },
    closeModal() {
      this.showModal = false;
      this.otpCode = "";
      this.userID = "";
    },
    generateOTP(user_id) {
      console.log("-----------");
      console.log(user_id);
      this.userID = user_id;
      this.divvy_admin_username = localStorage.getItem("loginUsername");
      
      let data = {
        divvy_admin_username: this.divvy_admin_username,
        user_id: user_id.toString()
      };
      
      FrontendService.divvyAdminGenerateOTP(data)
        .then((resp) => {
          if (resp.status !== 200) {
            console.log(resp);
            const errorMessage = resp.data?.message || "Unknown error occurred";
            console.log(errorMessage);
            this.showModal = false;
            throw new Error(errorMessage);
          } else {
            this.showModal = true;
          }
        })
        .catch((error) => {
          console.log("================================");
          let errorMessage = "An error occurred while generating OTP";
          
          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.response?.message) {
            errorMessage = error.response.message;
          } else if (error.message) {
            errorMessage = error.message;
          }
          
          console.log(errorMessage);
          this.showError(errorMessage);
        });
    },
    submitOtp() {
      const rawToken = `${this.divvy_admin_username}:${this.userID}:${this.otpCode}`;
      const encodedToken = btoa(
        new Uint8Array(new TextEncoder().encode(rawToken))
          .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );

      this.closeModal();
      this.$store.dispatch("user/setIsDivvyAdmin", false);
      localStorage.removeItem("isDivvyAdmin");
      this.$router.push({
        name: 'AutoLogin',
        query: {
          token: encodedToken,
          is_divvy_admin_flow: "true"
        }
      });
    },
    showError: function (message) {
      this.$bvModal.msgBoxOk(message, {
        size: "sm",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    // http://localhost:8080/autologin?token=23CDAB31
    adminType(admin) {
      const adminType = {
        0: "No",
        1: "Full Admin",
        2: "Client Admin",
        3: "Ameritech Coach",
        4: "Ameritech Sr.Manager",
        5: "Ameritech President",
        6: "Ameritech Vice-President",
        7: "Ameritech Regional Director",
      };
      return adminType[admin];
    },
  },
};
</script>

<style lang="scss" scoped>
.table td {
  padding: 10px 10px !important;
}
/* Button styles */
.btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  &-primary {
    background-color: #007bff;
    color: white;
    border: none;
  }
  &-success {
    background-color: #28a745;
    color: white;
    border: none;
  }
}

/* Modal styles */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.65) !important; /* Darker backdrop */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1 !important; /* Force opacity */
}

.modal-content {
  background: white !important;
  padding: 25px;
  border-radius: 8px;
  width: 450px;
  max-width: 95%;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 10000;
  border: 1px solid #e0e0e0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  h3 {
    margin: 0;
  }
  button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

.otp-input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.modal-header,
.modal-body,
.modal-footer {
  background: white !important;
  opacity: 1 !important;
}

/* Add this to prevent any inherited transparency */
.modal-content * {
  opacity: 1 !important;
}

.table-container {
  position: relative;
  z-index: 1; /* Lower than modal */
}
</style>
